import { useState } from 'react';
import Map from './ChargersLocationMap/Map';
import Marker from './ChargersLocationMap/Marker';
import MarkerClusterer from './ChargersLocationMap/MarkerClusterer';
import { noop, map, get, countBy, forIn, find, toNumber } from 'lodash-es';
import { differenceInSeconds } from 'date-fns';

export default function JoulepointMap({ mapType, records }) {
  // eslint-disable-next-line no-unused-vars
  const [bound, setBound] = useState({});

  function makeTitle(record) {
    if (mapType === 'chargers') {
      return record.chargerName;
    } else if (mapType === 'customer_charging_sessions') {
      return `Charger ${get(record, 'chargerName')}, ${get(
        record,
        'sessions',
      )} sessions`;
    }
  }

  function makeLabel(record) {
    if (mapType === 'chargers') {
      return record.chargerName;
    } else if (mapType === 'customer_charging_sessions') {
      return `${get(record, 'sessions')} sessions`;
    }
  }

  function isChargerOnline(LAST_HEARTBEAT, chargerConfig) {
    let chargerConfiguration = {};
    if (chargerConfig) {
      chargerConfiguration = JSON.parse(chargerConfig);
    }

    const chargerHearBeatConfigObj = find(
      get(chargerConfiguration, 'configurationKey'),
      { key: 'HeartbeatInterval' },
    );
    const chargerHeartBeatInterval = toNumber(
      get(chargerHearBeatConfigObj, 'value'),
    );
    const diffInSeconds = differenceInSeconds(
      new Date(),
      new Date(LAST_HEARTBEAT),
    );
    return diffInSeconds <= chargerHeartBeatInterval;
  }

  function generateLocationsOfChargingSessions() {
    if (mapType === 'customer_charging_sessions') {
      const chargingSessions = map(records, (record) => {
        return {
          chargingSessionId: get(record, 'NOTE.TRANSACTION.TRANSACTIONID'),
          chargerId: get(record, 'NOTE.CHARGER.ID'),
          chargerName: get(record, 'NOTE.CHARGER.NAME'),
          address: get(record, 'NOTE.CHARGER.ADDRESS'),
          lat: get(record, 'NOTE.CHARGER.LATITUDE'),
          lng: get(record, 'NOTE.CHARGER.LONGITUDE'),
          jointCoords: get(record, 'NOTE.CHARGER.COORDS'),
        };
      });

      const sessionsByLocation = countBy(chargingSessions, 'jointCoords');

      let finalArray = [];
      forIn(sessionsByLocation, (val, key) => {
        const cuurentChargerThatHadSessio = find(
          chargingSessions,
          (session) => {
            return get(session, 'jointCoords') === key;
          },
        );

        finalArray.push({
          chargerId: get(cuurentChargerThatHadSessio, 'chargerId'),
          chargerName: get(cuurentChargerThatHadSessio, 'chargerName'),
          address: get(cuurentChargerThatHadSessio, 'address'),
          lat: get(cuurentChargerThatHadSessio, 'lat'),
          lng: get(cuurentChargerThatHadSessio, 'lng'),
          jointCoords: get(cuurentChargerThatHadSessio, 'jointCoords'),
          sessions: val,
        });
      });

      return finalArray;
    } else if (mapType === 'chargers') {
      return map(records, (charger) => {
        return {
          lat: get(charger, 'LATITUDE'),
          lng: get(charger, 'LONGITUDE'),
          chargerId: get(charger, 'ID'),
          address: get(charger, 'ADDRESS'),
          chargerName: get(charger, 'NAME'),
          chargerConfig: get(charger, 'CHARGER_CONFIGURATION'),
          lastHeartBeat: get(charger, 'LAST_HEARTBEAT'),
        };
      });
    }
  }

  return (
    <>
      <Map
        zoom={4}
        center={{ lat: 24.367113562651, lng: 80.68359375 }}
        events={{ onBoundsChangerd: (arg) => setBound(arg) }}
      >
        <MarkerClusterer>
          {map(generateLocationsOfChargingSessions(), (obj, index) => (
            <Marker
              key={index}
              active={isChargerOnline(obj.lastHeartBeat, obj.chargerConfig)}
              title={makeTitle(obj)}
              label={makeLabel(obj)}
              position={{ lat: obj.lat, lng: obj.lng }}
              events={{
                onClick: () => noop(),
              }}
            />
          ))}
        </MarkerClusterer>
      </Map>
    </>
  );
}
